import { Chip } from '@mui/material'
import { BootstrapTooltip } from './BootstrapTooltip'
import { UnavailableValue } from './UnavailableValue'
import { IConversionTotals } from 'store/modules/report/types'
import { FUTURE_SALES_MESSAGE } from 'utils/reportDisabledFields'
import {
  CONVERSION_UNAVAILABLE_MESSAGE,
  formatConversionRate,
  getConversionColor,
  getConversionRate
} from 'utils/conversion'

interface ConversionValueProps {
  conversion?: IConversionTotals | null
  // Conversão do recorte (regional ou todas as lojas) usada para colorir a loja
  referenceRate?: number
  salesDisabled?: boolean
  variant?: 'badge' | 'text'
}

// Taxa de conversão nas tabelas de lojas, no mesmo formato do "Último ano":
// badge na linha de totais e texto colorido nas linhas das lojas.
export const ConversionValue = ({
  conversion,
  referenceRate,
  salesDisabled = false,
  variant = 'text'
}: ConversionValueProps) => {
  const rate = getConversionRate(conversion)

  if (salesDisabled) return <UnavailableValue message={FUTURE_SALES_MESSAGE} />
  if (!conversion || typeof rate !== 'number') {
    return <UnavailableValue message={CONVERSION_UNAVAILABLE_MESSAGE} />
  }

  const detail = `${conversion.sales.toLocaleString('pt-BR')} vendas de ${conversion.visitors.toLocaleString('pt-BR')} pessoas`

  return (
    <BootstrapTooltip title={detail}>
      {variant === 'badge' ? (
        <Chip
          size='small'
          label={formatConversionRate(rate)}
          sx={{
            height: 18,
            fontSize: '0.7rem',
            fontWeight: 600,
            padding: '4px',
            borderRadius: '9999px',
            color: 'white',
            backgroundColor: '#2A3ECB',
            '& .MuiChip-label': {
              padding: '0 2px'
            }
          }}
        />
      ) : (
        <span
          style={{
            fontSize: '11px',
            fontWeight: 'bold',
            color: getConversionColor(rate, referenceRate)
          }}
        >
          {formatConversionRate(rate)}
        </span>
      )}
    </BootstrapTooltip>
  )
}
